module.exports = __webpack_public_path__ + "static/media/dm3.84658676.svg";